import React from "react";

import { isElectron } from "@/utils";

/**
 * Wrapper for Electron Only Components
 * If the app is not running in Electron, it will return an empty fragment
 * @param children
 * @constructor
 */
const ElectronComponentLoader = ({ component }: { component: React.ReactNode }) => {
  if (!isElectron) {
    return <></>;
  }
  return <>{component}</>;
};

export default ElectronComponentLoader;
